/**
 * WebMCP 移动工具
 * 控制方块左移、右移、下移
 */
/* eslint-disable */
var want = require('../../unit/').want;
var t = require('../lang').t;
var actions = require('../../actions').default;
var states = require('../../control/states').default;
var delays = require('../../unit/const').delays;
var speeds = require('../../unit/const').speeds;
var music = require('../../unit/music').music;
var store = require('../../store').default;

/**
 * 执行移动操作
 */
function move(direction) {
  var state = store.getState();

  // 检查锁定状态
  if (state.get('lock')) {
    return { success: false, error: t('游戏处于锁定状态，无法移动', 'Game is locked, cannot move') };
  }

  var cur = state.get('cur');

  // 检查是否有当前方块
  if (cur === null) {
    return { success: false, error: t('没有活动方块', 'No active block') };
  }

  // 如果游戏暂停，先恢复
  if (state.get('pause')) {
    states.pause(false);
  }

  // 执行移动
  var next;
  if (direction === 'left') {
    next = cur.left();
  } else if (direction === 'right') {
    next = cur.right();
  } else if (direction === 'down') {
    next = cur.fall();
  } else {
    return { success: false, error: t('无效的移动方向: ', 'Invalid move direction: ') + direction };
  }

  var matrix = state.get('matrix');
  var canMove = want(next, matrix);

  if (canMove) {
    // 播放移动音效
    if (music.move) {
      music.move();
    }

    // 如果是向下移动，添加延迟
    if (direction === 'down') {
      var delay = delays[state.get('speedRun') - 1];
      next.timeStamp += parseInt(delay, 10);
    }

    store.dispatch(actions.moveBlock(next));

    // 如果是向下移动，重新计算自动下落时间
    if (direction === 'down') {
      var remain = speeds[state.get('speedRun') - 1] - (Date.now() - next.timeStamp);
      states.auto(remain);
    }

    return {
      success: true,
      message: t('方块已', 'Block moved ') + (direction === 'left' ? t('左移', 'left') : direction === 'right' ? t('右移', 'right') : t('下移', 'down')),
      // xy 是 [row, col] 即 [y, x]，转换为 [x, y] 格式
      position: (function() {
        var xy = next.xy;
        if (xy && typeof xy.get === 'function') {
          return [xy.get(1), xy.get(0)];  // [col, row] = [x, y]
        } else if (xy && Array.isArray(xy)) {
          return [xy[1], xy[0]];
        } else {
          return [0, 0];
        }
      })(),
    };
  }

  // 碰壁时更新时间戳但不移动
  if (direction === 'left' || direction === 'right') {
    var delay = delays[state.get('speedRun') - 1];
    cur.timeStamp += parseInt(parseInt(delay, 10) / 1.5, 10);
    store.dispatch(actions.moveBlock(cur));
  }

  return {
    success: false,
    error: t('无法', 'Cannot move ') + (direction === 'left' ? t('左移', 'left') : direction === 'right' ? t('右移', 'right') : t('下移', 'down')) + t('，被阻挡', ', blocked'),
  };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
  name: 'tetris_move',
  description: t('移动当前方块。支持三个方向：左(left)、右(right)、下(down)', 'Move the current block. Three directions: left, right, down'),
  inputSchema: {
    type: 'object',
    properties: {
      direction: {
        type: 'string',
        enum: ['left', 'right', 'down'],
        description: t('移动方向', 'Move direction'),
      },
    },
    required: ['direction'],
  },
  execute: function(args) {
    var result = move(args.direction);
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/move.js